<template>
  <div class="min-h-screen font-inter">
    <main class="w-full">
      <div
        class="w-full h-auto min-h-screen mt-3 rounded-t-[20px] bg-gray-50 dark:bg-background"
      >
        <div class="md:flex gap-8">
          <div class="w-full md:w-32 px-4 pt-6 md:py-6 md:pl-8 flex-shrink-0">
            <BackButton />
          </div>

          <div class="flex-1 px-4 md:px-0 py-2 md:py-6 md:pr-9">
            <LearningGoalsAllComponent />
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import BackButton from "@/components/BackButton.vue";
import LearningGoalsAllComponent from "@/components/learning-goals/LearningGoalsAllComponent.vue";

export default {
  name: "LearningGoalsAll",
  components: {
    BackButton,
    LearningGoalsAllComponent,
  },
};
</script>

<style scoped></style>
